import { __generator } from "tslib";
import { put, fork, select, takeLatest, takeEvery, all, } from 'redux-saga/effects';
import cookies from 'js-cookie';
import * as actionTypes from '../constants/actionTypes';
import * as actionCreators from '../actionCreators';
import { LEAVE_COMMENT_POPOVER_COOKIE } from '../constants/cookies';
import { getProjectID } from '../selectors/project';
var ONE_YEAR = 365;
function readLeaveCommentCookie() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actionTypes.GET_LEAVE_COMMENT_POPOVER_COOKIE, function () {
                    var value;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                value = cookies.get(LEAVE_COMMENT_POPOVER_COOKIE);
                                return [4 /*yield*/, put(actionCreators.receiveLeaveCommentPopoverCookie(value === 'true'))];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function setLeaveCommentCookie() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.SET_LEAVE_COMMENT_POPOVER_COOKIE, function () {
                    var projectID;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(getProjectID)];
                            case 1:
                                projectID = _a.sent();
                                cookies.set(LEAVE_COMMENT_POPOVER_COOKIE, 'true', {
                                    expires: ONE_YEAR,
                                    path: "/prototype/" + projectID,
                                });
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function cookiesSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([fork(readLeaveCommentCookie), fork(setLeaveCommentCookie)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
